export var ObservationTriggerStatus;
(function (ObservationTriggerStatus) {
    ObservationTriggerStatus["Active"] = "active";
    ObservationTriggerStatus["Inactive"] = "inactive";
})(ObservationTriggerStatus || (ObservationTriggerStatus = {}));
export var ObservationTriggerActionType;
(function (ObservationTriggerActionType) {
    ObservationTriggerActionType["Alarm"] = "alarm";
    ObservationTriggerActionType["Sms"] = "sms";
    ObservationTriggerActionType["Email"] = "email";
})(ObservationTriggerActionType || (ObservationTriggerActionType = {}));
export var ObservationTriggerFilterType;
(function (ObservationTriggerFilterType) {
    ObservationTriggerFilterType["AndOperator"] = "operator/and";
    ObservationTriggerFilterType["OrOperator"] = "operator/or";
    ObservationTriggerFilterType["AssetConstraint"] = "constraint/asset";
    ObservationTriggerFilterType["AssetGroupConstraint"] = "constraint/assetGroup";
    ObservationTriggerFilterType["ZoneConstraint"] = "constraint/zone";
    ObservationTriggerFilterType["ScheduleConstraint"] = "constraint/schedule";
})(ObservationTriggerFilterType || (ObservationTriggerFilterType = {}));
